/*
 * wp-shared.js
 * WordPress版 assets/js/shared.js・modules/utility.js 由来の共通挙動を集約。
 * Shopify テーマ assets/ に配置し、移行ページで {{ 'wp-shared.js' | asset_url }} で読み込む。
 * （共通CSSの wp-shared.css と対になる共通JS。ページ固有のJSは各テンプレートにインラインする）
 */
(function () {
  "use strict";

  /**
   * 対象要素がビューポートに入ったら is-animated を付与する（元 utility.js の scrollAddClass）。
   * .c-image::before の不透明オーバーレイは .c-image.is-animated で消えるため、この付与が必須。
   * ページ固有セレクタにも使えるよう window.wpShared.scrollAddClass として公開する。
   *
   * @param {string} selector 対象セレクタ
   * @param {{startDelay?: number, mode?: "default"|"alternate"}} [args]
   */
  function scrollAddClass(selector, args) {
    selector = selector || ".js-scroll-add-class";
    var settings = Object.assign({ startDelay: 0.25, mode: "default" }, args || {});
    var allElem = document.querySelectorAll(selector);

    Array.prototype.slice.call(allElem).forEach(function (elem) {
      var offsetTop = elem.getBoundingClientRect().top + window.scrollY;
      var startDelay = elem.dataset.startDelay || settings.startDelay;

      if (
        window.scrollY + window.innerHeight - window.innerHeight * startDelay >=
        offsetTop
      ) {
        if (!elem.classList.contains("is-animated")) {
          elem.classList.add("is-animated");
          elem.dispatchEvent(new Event("classAdded"));
        }
      } else if (settings.mode === "alternate") {
        elem.classList.remove("is-animated");
      }
    });
  }

  // ページ固有の呼び出し用に公開
  window.wpShared = window.wpShared || {};
  window.wpShared.scrollAddClass = scrollAddClass;

  // 共通: .c-image の表示（全移行ページ共通。shared.js と同じく load/scroll/resize で発火）
  var revealImages = function () {
    scrollAddClass(".c-image");
  };

  if (document.readyState === "loading") {
    window.addEventListener("DOMContentLoaded", revealImages);
  } else {
    revealImages();
  }
  window.addEventListener("load", revealImages);
  window.addEventListener("scroll", revealImages, { passive: true });
  window.addEventListener("resize", revealImages);
})();
